import React, { useState, useEffect } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Row,
  Col,
  Container,
} from "reactstrap";

import Loading from 'lib/loading'
import rotas from 'services/rotas'
import rest from 'lib/rest'
import CardProjecao from "./cardProjecao";

const EstatisticaProjecao = () => {

  const [loading, setLoading]         = useState(false)
  const [loadingHoje, setLoadingHoje] = useState(true)
  const [loadingMes, setLoadingMes]   = useState(true)
  const [loadingAno, setLoadingAno]   = useState(true)
  const [dadosHoje, setDadosHoje]     = useState([])
  const [dadosMes, setDadosMes]       = useState([])
  const [dadosAno, setDadosAno]       = useState([])
  const listaProjecao = (tipo) => {

    const url     = rotas.estatisticaProjecao+'?tipo='+tipo;
    const retorno = rest.get(url);

    retorno.then(ret => {
      console.log(ret);
      if (ret.success && ret.success === 'S' && ret.lista !== '' && ret.lista !== null) {
        if (tipo === 'hoje') {
          setDadosHoje(ret.lista)
          setLoadingHoje(false)
        } else if(tipo === 'mes') {
          setDadosMes(ret.lista)
          setLoadingMes(false)
        } else if(tipo === 'ano') {
          setDadosAno(ret.lista)
          setLoadingAno(false)
        }
      }
      setLoading(false)
    })
  }

  useEffect(() => {
    listaProjecao('hoje')
    listaProjecao('mes')
    listaProjecao('ano')

    const interval = setInterval(() => {
      setLoadingHoje(true)
      setLoadingMes(true)
      setLoadingAno(true)

      listaProjecao('hoje');
      listaProjecao('mes');
      listaProjecao('ano');
    }, 2 * 60 * 1000); // 2 minutos
    return () => clearInterval(interval);

  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  if (loading) {
    return ( <Loading tipo='paginas' />  )

  } else {
    return (
      <div className="content" key="585">
        <Container>
          <Row>
            <Col md="12" className="p-0">
              <Card>
                <CardHeader>
                  <CardTitle>ESTATÍSTICA DE PROJEÇÃO</CardTitle>
                </CardHeader>

                <CardBody>

                  <Row>
                    <Col md="4">
                      {loadingHoje ? <Loading tipo='componente' /> :
                        <CardProjecao
                          title = 'HOJE'
                          color = '#eeffd2'
                          dados = {dadosHoje}
                        />
                      }
                    </Col>

                    <Col md="4">
                      {loadingMes ? <Loading tipo='componente' /> :
                        <CardProjecao
                          title = 'MÊS ATUAL'
                          color = '#d2e9ff'
                          dados = {dadosMes}
                        />
                      }
                    </Col>

                    <Col md="4">
                      {loadingAno ? <Loading tipo='componente' /> :
                        <CardProjecao
                          title = 'ANO ATUAL'
                          color = '#fff8d2'
                          dados = {dadosAno}
                        />
                      }
                    </Col>
                    <Col md="12" className='text-center'>
                      <h6 className="card-category">* Valores baseados no dia e hora atual</h6>
                    </Col>
                  </Row>

                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }



}

export default EstatisticaProjecao
